import { render, staticRenderFns } from "./publication-card.vue?vue&type=template&id=d59a70c4&"
import script from "./publication-card.vue?vue&type=script&lang=js&"
export * from "./publication-card.vue?vue&type=script&lang=js&"
import style0 from "./publication-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d59a70c4')) {
      api.createRecord('d59a70c4', component.options)
    } else {
      api.reload('d59a70c4', component.options)
    }
    module.hot.accept("./publication-card.vue?vue&type=template&id=d59a70c4&", function () {
      api.rerender('d59a70c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/news/publication-card.vue"
export default component.exports